import React, { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from "react-redux";
import Sidebar from './../Sidebar';
import ContactSearch from '../ContactBook/ContactSearch';
import ProductSearch from '../ProductMaster/ProductSearch';
import Swal from "sweetalert2";
import { requestPurchaseById, requestUpdatePurchase } from "../../Redux/actions";
import { bindActionCreators } from "redux";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";

import {
    Box,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper
} from '@mui/material';
import { el } from 'date-fns/locale';
import ContactAdd from './../ContactBook/ContactAdd';
import ProductAdd from './../ProductMaster/ProductAdd';
import StoreSearch from '../Store/StoreSearch';
import { parse, set } from 'date-fns';
import StoreAdd from '../Store/StoreAdd';

function PurchaseEdit(props) {
    const [billdata, setBillData] = useState({
        custId: 0, billNo: "", billDate: null, dueDate: null, person: "", discount: 0, discountpercent: 0, other: 0,
        total: 0, grandTotal: 0, paid: 0, balance: 0
    });
    const [products, setProducts] = useState(null);

    const [errorBillNo, seterrorBillNo] = useState("");
    const [errorBillDate, seterrorBillDate] = useState(null);
    const { id } = useParams();
    const [selectedContact, setSelectedContact] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [cartData, setCartData] = useState(null);
    const [contactmodal, setContactModal] = useState(false);
    const [productmodal, setproductModal] = useState(false);

    useEffect(() => {
        if (selectedProduct) {
            if (selectedContact === null) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Select Contact first.',
                    icon: 'error'
                });
            } else {
                const current = Array.isArray(products) ? products : [];
                const exists = current.some(p => p.id === selectedProduct.id);
                if (exists) return;

                const newItem = {
                    id: 0,
                    item_id: selectedProduct.id,
                    item_name: selectedProduct.description,
                    rate: selectedProduct.rate,
                    qty: 1,
                    discper: 0,
                    disc: 0,
                    taxPer: 0,
                    cgst: 0,
                    sgst: 0,
                    igst: 0,
                    amount: selectedProduct.rate
                };

                const updated = [...current, newItem];

                // 🧩 Save to localStorage
                const dataToSave = {
                    products: updated,
                    contact: selectedContact,
                    billInfo: billdata
                };

                localStorage.setItem(`Purchase_${selectedContact.custId}`, JSON.stringify(dataToSave));

                // 🧠 Update all relevant states
                console.log("Updated Products:", updated);
                setProducts(updated);
                setCartData(prev => ({ ...prev, items: updated }));
                setSelectedProduct(null); // use null instead of empty array to avoid logic collisions
            }
        }
    }, [selectedProduct]);

    const totalAmount = (products || []).reduce((sum, item) => sum + item.amount, 0);
    console.log("totalAmount:", totalAmount);
    useEffect(() => {
        const discountAmount = (totalAmount * billdata.discountpercent) / 100;
        const grandTotal = totalAmount - discountAmount + parseFloat(billdata.other);
        const balance = grandTotal - parseFloat(billdata.paid);

        setBillData(adddata => ({
            ...adddata,
            total: totalAmount,
            discountAmount: discountAmount,
            balance: balance,
            grandTotal: grandTotal
        }));
    }, [totalAmount, billdata.other, billdata.discountpercent, billdata.paid]);

    function handleNewClient(e) {
        e.preventDefault();
        contacttoggle();
    }
    function handleNewProduct(e) {
        e.preventDefault();
        producttoggle();
    }

    function validateBillNo() {
        let formIsValid = false;
        console.log(billdata);
        if (!billdata["billNo"]) {
            formIsValid = false;
            seterrorBillNo("*Enter Bill No.");
        } else {
            formIsValid = true;
            seterrorBillNo("");
        }
        return formIsValid;
    }

    function validateBillDate() {
        let formIsValid = false;

        if (!billdata.billDate) {
            formIsValid = false;
            seterrorBillDate("*Enter a Bill date.");
        }
        else {
            formIsValid = true;
            seterrorBillDate("");
        }

        return formIsValid;
    }

    function validateAddForm() {
        let billno = validateBillNo(); let billdate = validateBillDate();
        console.log(billno, billdate);
        let valid = billno && billdate;
        if (!valid) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill all the required fields correctly.",
            });
        }
        return valid;
    }

    const onchangeadddata = (event) => {
        setBillData((adddata) => ({
            ...adddata,
            [event.target.name]: event.target.value,
        }));
    };

    useEffect(() => {
        let data1 = JSON.parse(localStorage.getItem("user"));
        props.requestPurchaseById({
            data: {
                token: id,
                userToken: data1.data.userToken
            },
        });
    }, [id]);

    useEffect(() => {
        let jobsData = props.data.purchaseByIdData;
        console.log("jobsData", jobsData.data);
        if (jobsData !== undefined) {
            if (jobsData.data) {
                if (jobsData.data.data[0] !== undefined) {
                    setBillData(jobsData.data.data[0]);
                    //                    setCartData(jobsData.data.cart);
                    setProducts(jobsData.data.cart);
                    setCartData(prev => ({ ...prev, items: jobsData.data.data[0] }));
                    setSelectedContact(jobsData.data.data[0]);
                    const tableKey = `Purchase_${jobsData.data.data[0].custId}`;
                    const storedData = JSON.parse(localStorage.getItem(tableKey)) || {};
                    const updatedTableData = {
                        ...storedData,              // Keeps contact, tableNo, etc.
                        products: jobsData.data.cart  // Replaces only the products array
                    };

                    // 💾 Save back to localStorage
                    localStorage.setItem(tableKey, JSON.stringify(updatedTableData));
                }
            }
        }
    }, [props.data.purchaseByIdData]);

    const formatDateForInput = (dateString) => {
        if (!dateString) return ""; // Handle null or undefined dates
        const [month, day, year] = dateString.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    function deletedata(idToDelete) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const tableKey = `Purchase_${selectedContact.custId}`;
                const storedData = JSON.parse(localStorage.getItem(tableKey)) || {};

                // 🛡️ Safe fallback if products don't exist
                const currentProducts = Array.isArray(storedData.products) ? storedData.products : [];

                // 🔍 Remove only the product with the matching id
                const updatedProducts = currentProducts.filter(item => item.id !== idToDelete);
                setProducts(updatedProducts);
                // 🧩 Preserve other table data
                const updatedTableData = {
                    ...storedData,              // Keeps contact, tableNo, etc.
                    products: updatedProducts  // Replaces only the products array
                };

                // 💾 Save back to localStorage
                localStorage.setItem(tableKey, JSON.stringify(updatedTableData));

                // 🔄 Update UI
                // setProductList(updatedProducts);
                setCartData(prev => ({ ...prev, items: updatedProducts }));
            }
        })
    }

    const handleQtyChange = (id, field, value) => {
        const updatedList = products.map(item => {
            if (item.item_id !== id) return item;

            const updatedItem = { ...item, [field]: value };

            const discount = updatedItem.discper > 0
                ? (updatedItem.rate * updatedItem.discper) / 100
                : updatedItem.disc ?? 0;

            updatedItem.disc = discount;
            const baseAmount = updatedItem.rate - discount;
            const totalTax = updatedItem.taxPer > 0
                ? (baseAmount * updatedItem.taxPer) / 100
                : (updatedItem.cgst ?? 0) + (updatedItem.sgst ?? 0) + (updatedItem.igst ?? 0);
            updatedItem.cgst = totalTax / 2;
            updatedItem.sgst = totalTax / 2;
            updatedItem.amount = updatedItem.qty * (baseAmount + totalTax);

            return updatedItem;
        });

        setProducts(updatedList);
    };

    function saveCartToApi() {
        if (validateAddForm()) {
            let data1 = JSON.parse(localStorage.getItem("user"));
            let tableKey = `Purchase_${selectedContact.custId}`;
            let storedData = JSON.parse(localStorage.getItem(tableKey)) || {};
            let cartData = {
                ...storedData,
                contact: selectedContact,
                billNo: billdata.billNo,
                billDate: billdata.billDate,
                dueDate: billdata.dueDate,
                person: billdata.person,
                discount: billdata.discount,
                discountpercent: billdata.discountpercent,
                other: billdata.other,
                total: billdata.total,
                grandTotal: billdata.grandTotal,
                paid: billdata.paid,
                balance: billdata.balance
            };

            props.requestUpdatePurchase({
                data: {
                    userToken: data1.data.userToken,
                    compToken: localStorage.getItem("companyToken"),
                    // custId: selectedContact.custId,
                    cartDatas: products,
                    billInfo: billdata
                },
            });
        }
    }
    const producttoggle = () => {
        setproductModal(prev => !prev);
    };
    const contacttoggle = () => {
        setContactModal(prev => !prev);
    };
    return (
        <Fragment>
            <div class="container-scroller">
                {/* <PageHeader name="Jobs" /> */}
                <div class="container-fluid page-body-wrapper">
                    <Sidebar name="Jobs" />
                    <div class="main-panel">
                        <div class="content-wrapper">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="home-tab">
                                        <div class="row flex-grow">
                                            <div class="grid-margin stretch-card">
                                                <div class="card card-rounded">
                                                    <div class="row card-body">
                                                        <div class="col-md-4 card mb-3">
                                                            <div class="card-body">
                                                                <div className="form-group">
                                                                    <ContactSearch onContactSelect={(contact) => {
                                                                        setSelectedContact(contact);
                                                                        setCartData(prev => ({
                                                                            ...prev,
                                                                            contact: contact // 💾 Save into cartData
                                                                        }));
                                                                    }} />
                                                                    <br></br><br></br>
                                                                    {selectedContact !== null ? <div className='row'> <label className="form-label"><b>Name:</b> {selectedContact.name}</label>
                                                                        <p><b>Phone No:</b> {selectedContact.mobile}</p>
                                                                        <p><b>Email:</b> {selectedContact.email}</p>
                                                                        <div className='row'>{selectedContact.address}</div>
                                                                    </div> : <p>Select Vendor</p>}
                                                                </div>
                                                                <button type='button' className='bg-primary' style={{ width: "20px" }} onClick={(e) => handleNewClient(e)}><i className='fa fa-plus' /></button>
                                                                {contactmodal === true && (
                                                                    <Modal
                                                                        isOpen={contactmodal}
                                                                        toggle={contacttoggle}
                                                                        zIndex='999'
                                                                    >
                                                                        <ModalHeader toggle={contacttoggle}>
                                                                            Contact Details
                                                                        </ModalHeader>
                                                                        <ModalBody>
                                                                            <ContactAdd></ContactAdd>
                                                                        </ModalBody>
                                                                    </Modal>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4 card mb-3">
                                                            <div class="card-body">
                                                                <div className="row">
                                                                    <div className='col-md-6'><input type="text" name='billNo' className="form-control" placeholder="Bill No" value={billdata.billNo} onChange={onchangeadddata} onBlur={validateBillNo}></input>{errorBillNo && <p>{errorBillNo}</p>}</div>
                                                                    <div className='col-md-6'><input type="date" name='billDate' className="form-control" placeholder="Bill Date" value={formatDateForInput(billdata.billDate)} onChange={onchangeadddata} onBlur={validateBillDate}></input>{errorBillDate && <p>{errorBillDate}</p>}</div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className='col-md-6'>Due Date</div>
                                                                    <div className='col-md-6'><input type="date" name='dueDate' className="form-control" placeholder="Due Date" onChange={onchangeadddata} value={billdata.dueDate ? formatDateForInput(billdata.dueDate) : ""}></input></div>
                                                                </div>
                                                                <input type="text" name='person' className="form-control" placeholder="Person" onChange={onchangeadddata}></input>
                                                            </div>
                                                        </div>
                                                        <div class="card mb-3">
                                                            <div class="card-body form-fields">
                                                                <div className='row'>
                                                                    <StoreSearch onStoreelect={(p) => setSelectedProduct(p)}></StoreSearch>
                                                                    <button className='badge badge-opacity-warning' style={{ width: "50px" }} onClick={(e) => handleNewProduct(e)}><i className='fa fa-plus'></i></button>
                                                                    {productmodal === true && (
                                                                        <Modal
                                                                            isOpen={productmodal}
                                                                            toggle={producttoggle}
                                                                            zIndex='999'
                                                                        >
                                                                            <ModalHeader toggle={producttoggle}>
                                                                                Add Product
                                                                            </ModalHeader>
                                                                            <ModalBody>
                                                                                <StoreAdd></StoreAdd>
                                                                            </ModalBody>
                                                                        </Modal>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card mb-3">
                                                            <div class="row card-body form-fields">
                                                                <Box sx={{ overflowX: 'auto' }}>
                                                                    <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
                                                                        <Table stickyHeader size="small">
                                                                            <TableHead>
                                                                                <TableRow>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>#</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Item Name</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Price</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Qty</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Disconut %</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Disconut</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Tax</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>CGST</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>SGST</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>IGST</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Amount</TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {Array.isArray(products) ? products.map((item, index) => (
                                                                                    <TableRow
                                                                                        key={index}
                                                                                        hover
                                                                                        sx={{
                                                                                            cursor: 'pointer',
                                                                                            backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5' // Light gray for odd rows
                                                                                        }}
                                                                                    >
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{index + 1}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.item_name || '—'}</TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.rate}
                                                                                                onChange={(e) => handleQtyChange(item.item_id, 'rate', parseFloat(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.qty}
                                                                                                onChange={(e) => handleQtyChange(item.item_id, 'qty', parseFloat(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.discper}
                                                                                                onChange={(e) => handleQtyChange(item.item_id, 'discper', parseFloat(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.disc}
                                                                                                onChange={(e) => handleQtyChange(item.item_id, 'disc', parseFloat(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.taxPer}
                                                                                                onChange={(e) => handleQtyChange(item.item_id, 'taxPer', parseFloat(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.cgst}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.sgst}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.igst}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.amount}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}><button class="badge badge-opacity-danger" style={{ border: "0px", background: "#fea8a9", marginLeft: "5px", }}
                                                                                            onClick={() => { deletedata(item.id); }}><i class="fa fa-trash"></i></button></TableCell>
                                                                                    </TableRow>
                                                                                )) : ""}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Box>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <button onClick={() => {
                                if (selectedTable !== '') {
                                    setTables({ ...tables, [selectedTable]: cartData });
                                    alert('Data saved for table: ' + selectedTable);
                                }
                            }}>Save Table Data</button> */}
                            <div
                                style={{
                                    position: 'sticky',
                                    bottom: 0,
                                    width: '100%',
                                    background: '#fff',
                                    boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
                                    padding: '1rem',
                                    zIndex: 99
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flexWrap: 'wrap'
                                    }}
                                >

                                    <strong style={{ fontSize: '1.2rem' }}>Total: ₹{billdata.total}</strong>
                                    <div className='d-flex flex-row justify-content-between'>
                                        <input
                                            name='discountpercent'
                                            type='number'
                                            placeholder='Disc %'
                                            value={billdata.discountpercent}
                                            onChange={onchangeadddata}
                                            className='form-control mx-1 w-60'
                                        />
                                        <input name='discount' type='number' placeholder='Discount' className='form-control mx-1 w-60' disabled value={billdata.discount} />
                                        <input
                                            name='other'
                                            type='number'
                                            placeholder='Other'
                                            value={billdata.other}
                                            onChange={onchangeadddata}
                                            className='form-control mx-1 w-60'
                                        />
                                    </div>
                                    <div className='row'>
                                        <strong style={{ fontSize: '1.2rem' }}>Grand Total: ₹{billdata.grandTotal}</strong>
                                        <div className='d-flex flex-row justify-content-between'>
                                            <input
                                                name='paid'
                                                type='number'
                                                placeholder='Paid'
                                                value={billdata.paid}
                                                onChange={onchangeadddata}
                                                className='form-control mx-1 w-60'
                                            />
                                            <strong className='mx-1 w-60' style={{ fontSize: '1rem' }}> ₹{billdata.balance}</strong>
                                        </div>
                                    </div>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => { saveCartToApi() }}
                                    >
                                        Save Cart
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestPurchaseById, requestUpdatePurchase}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseEdit);